import { diffDays, diffHours, diffMinutes, diffMonths, diffSeconds, diffWeeks, diffYears, format, tzDate } from "@formkit/tempo";
import { i18n, t, tc } from ".";
import { getNestedKeyValue, type NestedKey } from "../nestedKey";

type DateTimeOptions = {
    locale?: Domain.UI.Enums.Locale | string;
    timezone?: string;
    relativeRoudingMethod?: "trunc" | "round" | "floor" | "ceil";
};

export const d = (
    date: string | Date,
    key: NestedKey<Omit<typeof i18n.value.translations.datetime, "relative" | "timezone">> | "relative",
    options: DateTimeOptions = {},
) => {
    let value = "";
    const tz = options?.timezone ?? getNestedKeyValue(i18n.value.translations.datetime, "timezone") ?? "UTC";
    const languageCode = options?.locale ?? `${i18n.value.locale}-${i18n.value.country}`;

    if (key === "relative") {
        const dateToFormat = tzDate(new Date(date), tz);
        const d = new Date();

        const diff = {
            years: diffYears(d, dateToFormat),
            months: diffMonths(d, dateToFormat),
            weeks: diffWeeks(d, dateToFormat, options?.relativeRoudingMethod),
            days: diffDays(d, dateToFormat, options?.relativeRoudingMethod),
            hours: diffHours(d, dateToFormat, options?.relativeRoudingMethod),
            minutes: diffMinutes(d, dateToFormat, options?.relativeRoudingMethod),
            seconds: diffSeconds(d, dateToFormat, options?.relativeRoudingMethod),
        };

        for (const [unit, amount] of Object.entries(diff) as [keyof typeof diff, number][]) {
            if (amount !== 0) {
                value = tc(`datetime.relative.${unit}`, Math.abs(amount) - 1, { count: Math.abs(amount) });
                value = amount < 0 ? t("datetime.relative.future", { value }) : t("datetime.relative.past", { value });
                break;
            }
        }
    } else {
        value = format({ date: new Date(date), format: getNestedKeyValue(i18n.value.translations.datetime, key), locale: languageCode, tz });
    }

    if (!value) return "";

    return value.trim();
};
